import React from 'react';

import { ValueBox, ValueGroup, ValueInput } from '@candu-ai/craft/ui';
import { VariableHelp, VariableSummary } from 'craft/components/ToolboxVariable';
import { Section, ValidationErrorMessages } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import { ThumbnailField } from 'craft/resolvers/Player/ThumbnailField';

import { AspectRatioField } from './AspectRatioField';

interface Props {
  nodeIds: string[];
}

export const PlayerToolbox = ({ nodeIds }: Props) => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  const onChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = target;
    setProps({ [name]: value });
  };
  return (
    <>
      <Section name="Player">
        <ValueGroup>
          <ValueBox label="Title" isInGroup={{ isFirst: true }}>
            <ValueInput
              value={props.title.value}
              defaultValue="Video Player"
              name="title"
              onChange={onChange}
            />
          </ValueBox>
          <ValueBox label="Aria-Label" isInGroup={{ isLast: true }}>
            <ValueInput value={props.ariaLabel.value} name="ariaLabel" onChange={onChange} />
          </ValueBox>
        </ValueGroup>
        <ValueGroup>
          <ValueBox label="Aspect Ratio" responsiveToggle>
            <AspectRatioField nodeIds={nodeIds} />
          </ValueBox>
          <ValidationErrorMessages nodeIds={nodeIds} />
        </ValueGroup>
        <ValueGroup>
          <ValueBox label="Source">
            <ValueInput
              name="src"
              value={props.src.value}
              onChange={onChange}
              placeholder="https://"
            />
          </ValueBox>
        </ValueGroup>
        {props.src.value ? <VariableSummary url={props.src.value} /> : null}
        <VariableHelp />
      </Section>
      <Section name="Thumbnail" tooltip="The image displayed during player loading">
        <ThumbnailField nodeIds={nodeIds} />
      </Section>
    </>
  );
};
